import { closeSerial, openSerial, readerData, readerDataSync } from '@/components/Cargo/FrontEndWarehouse/components/util/serial/util'
import { getPort } from './mySerialUtils.js'

export const serial = async(baudRate, jiaoyan) => {
  // 浏览器支持serial
  if ('serial' in navigator) {
    // console.log('当前浏览器支持serial--3')
    try {
      await openSerial(baudRate)
      return await readerData(jiaoyan)
    } catch (err) {
      console.error(err)
    } finally {
      await closeSerial()
    }
  } else {
    alert('你的浏览器不⽀持串⼝连接')
    return '0'
  }
}
export const serialSync = async(baudRate, jiaoyan, callback) => {
  // 浏览器支持serial
  if ('serial' in navigator) {
    // console.log('当前浏览器支持serial--3')
    try {
      await openSerial(baudRate)
      return await readerDataSync(jiaoyan, callback)
    } catch (err) {
      console.error(err)
    } finally {
      await closeSerial()
    }
  } else {
    alert('你的浏览器不⽀持串⼝连接')
    return '0'
  }
}

export const serialCheck = () => {
  return getPort()
}
